import React, { useEffect, useState, useRef } from "react";
import './dasboard.css'
import { AiOutlinePlus, AiFillDelete, AiOutlineMinus, Aifill } from 'react-icons/ai'
import axios from "axios";
import CapitalizeFirstLetter from "../components/common/commonFunctions";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import './deshboard4.css'

function Dashboard4() {
    const elementRef = useRef(null);
    const [arrowDisable, setArrowDisable] = useState(true);
    const [filters, setFilters] = useState([])
    const [joins, setJoins] = useState([])
    const [totalJoins, setTotalJoins] = useState([])
    const [listItems, setListItems] = useState([{ columnList: [{}] }])
    const [tables, setTables] = useState([])
    const [activeItem, setActiveItem] = useState(0)
    const [centercol, setCenterCol] = useState(0)
    const [allColumns, setAllColumns] = useState([])
    const [table, setTable] = useState()
    const [key, setKey] = useState()
    const [keys, SetKeys] = useState([])
    const [joinApp, setJoinApp] = useState(false)

    const [columnItems, setColumnItems] = useState([{ Column_Id: "", Column_name: "", Filter: "", Value: "", selected_operator: "AND" }])
    useEffect(() => {
        signIN()
    }, [])

    const handleHorizantalScroll = (element, speed, distance, step) => {
        let scrollAmount = 0;
        const slideTimer = setInterval(() => {
            element.scrollLeft += step;
            scrollAmount += Math.abs(step);
            if (scrollAmount >= distance) {
                clearInterval(slideTimer);
            }
            if (element.scrollLeft === 0) {
                setArrowDisable(true);
            } else {
                setArrowDisable(false);
            }
        }, speed);
    };

    var checkValidation = () => {
        let temp = [...listItems]
        temp.forEach(t => {
            if (t.selectedKey && t.join && t.table_selected) {
                t.validation = true
            }
            else {
                t.validation = false
            }
        })


    }

    function signIN() {
        axios.post(process.env.REACT_APP_API_POINT +"auth/login", { username: "saral", password: "saral" }, { headers: { "Content-Type": "application/x-www-form-urlencoded" } }).then((data) => {
            if (data.data.success == true) {
                sessionStorage.setItem('token', data.data.access_token)
                getTables()
                axios.get(process.env.REACT_APP_API_POINT + 'DQ-workflow/dq-custom-filters', { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((data) => {
                    if (data.data.success) {
                        let arr = []
                        let tempJoin = []
                        data.data['DQS-Custom-Filters'].forEach((filt) => {
                            if (filt['Filter Type'] == 'join') {
                                tempJoin.push(filt)
                            } else {
                                arr.push(filt)
                            }
                        })
                        setFilters(arr)
                        setJoins(tempJoin)
                    }
                })
            }
        })
    }


    function getTables() {
        axios.get(process.env.REACT_APP_API_POINT + 'DQ-workflow/dq-custom-schema', { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((data) => {
            if (data.data.success) {
                setTables(data.data['DQS-Custom-Schema'].source[0].table)

            }
        })
    }

    function selectTable(value, ind) {

        let col = [...allColumns]
        let temp = [...listItems]
        if (value && value != 'Select Table') {
            value = JSON.parse(value)
            if (temp[ind]["table_selected"]) {
                temp[ind]["table_selected"]['Columns'].forEach((c) => {

                    col.forEach((d, i) => {
                        if (d.display == temp[ind]["table_selected"]["Name"] + '.' + c['Column_Name']) {
                            if (d.count > 1) {
                                d.count--
                            } else {
                                col.splice(i, 1)
                            }
                        }
                    })
                })
            }
            temp[ind]["table_selected"] = value
            temp[ind]['keys'] = value.Primary_key
            setListItems(temp)
            value['Columns'].forEach((c) => {
                let flag = false
                col.forEach((d) => {
                    if (d.display == value["Name"] + '.' + c['Column_Name']) {
                        d.count++
                        flag = true
                    }
                })
                if (!flag) {
                    c.display = value["Name"] + '.' + c['Column_Name']
                    c.count = 1
                    col.push(c)
                }
            })
            selectColumn(JSON.stringify(col[0]), 0, true)
            setAllColumns(col)
        }
        else {

        }


    }

    function selectColumn(e, ind, basic) {

        let temp = [...columnItems]
        if (e && e != 'Select Column') {

            e = JSON.parse(e)
            temp[ind]["selected_column"] = basic ? null : e;
            if (e['Column_Description'] == 'int') {
                e['Column_Description'] = "number"
            }
            let arr = []
            filters.forEach((fil) => {
                if (fil['Filter Type'] == e['Column_Description'])
                    arr.push(fil)
            })
            temp[ind]["filters"] = arr
            if (temp[ind]['selected_filter']) {

                selectFilter(JSON.stringify(arr[0]), 0, true)
            }
            setColumnItems(temp)
        } else {
            temp[ind]["selected_column"] = null
            document.getElementById('filer').value = 'Filter'
            temp[ind]["selected_filter"] = null
        }
    }


    function selectJoin(ind, value) {

        if (value && value != 'Join') {
            value = JSON.parse(value)
            let temp = [...listItems]
            temp[ind].join = value
            console.log(temp)
            setListItems(temp)
        }

    }
    function selectKey(value, ind) {

        if (value) {
            value = value
            let temp = [...listItems]
            temp[ind].selectedKey = value
            setListItems(temp)
        }

    }







    function addTables() {
        if (!joinApp) {
            return
        }
        let temp = [...listItems]
        temp.push({ columnList: [{}] })
        setListItems(temp)
        if (temp.length % 2 == 0) {
            setCenterCol((temp.length / 2))
        }
        else {
            setCenterCol((temp.length - 1) / 2)
        }
        setTotalJoins([...totalJoins, {}])
    }

    useEffect(() => {
        if (!listItems[activeItem]) {
            setActiveItem(activeItem - 1)
        }
    })

    function addColumn() {
        let temp = [...columnItems]

        temp.push({ Column_Id: "", Column_name: "", Filter: "", Value: "", selected_operator: "AND" })
        console.log(temp)
        setColumnItems(temp)
    }

    function selectFilter(e, index, basic) {
        let temp = [...columnItems]
        if (e && e != 'Filter') {
            document.getElementById('filer').value = e
            e = JSON.parse(e)
            temp[index]['selected_filter'] = basic ? null : e
            setColumnItems(temp)
        }
        else {
            temp[index]['selected_filter'] = null

        }
    }
    function selectOperator(i, e) {
        if (e) {

            let temp = [...columnItems]
            temp[i]['selected_operator'] = e
            setColumnItems(temp)
        }
    }

    function selectValue(i, e) {
        let temp = [...columnItems]
        temp[i].value = e.target.value
        setColumnItems(temp)
    }

    function submit() {

        if ((joinApp && table && key) || (!joinApp) && table) {
            let tableArr = []
            let columnArr = []
            listItems.forEach((item) => {
                if (item.selectedKey && item.join && item.table_selected) {
                    let arr = { Table2: item.table_selected, Join_type: item.join, Table1: table.Name, Table1_key: key, Table2_key: item.selectedKey }
                    tableArr.push({ ...arr })
                }
            })


            columnItems.forEach((col) => {
                if (col.selected_column && col.selected_filter && col.selected_operator) {
                    let obj = {
                        Column_Id: col.selected_column ? col.selected_column.Id : "",
                        Column_name: col.selected_column ? col.selected_column.display : "",
                        Filter: col.selected_filter ? col.selected_filter['Filter Name'] : "",
                        operator: col.selected_operator
                    }

                    if ((col.selected_filter && (col.selected_filter['Filter Name'] != 'sum' && col.selected_filter['Filter Name'] != 'avg' && col.selected_filter['Filter Name'] != 'max' && col.selected_filter['Filter Name'] != 'min' && col.selected_filter['Filter Name'] != 'count'))) {
                        obj.value = col.value
                    }
                    if (obj.Column_Id && obj.Column_name) {
                        columnArr.push({ ...obj })
                    }
                }
            })

            let finalOutput = {
                Join: joinApp,
                Column: columnArr
            }

            if (joinApp) {
                finalOutput.Join_in = tableArr
            } else {
                finalOutput.Join_in = []

            }

            if ((finalOutput.Join && finalOutput.Join_in.length > 0 && finalOutput.Column.length > 0) || (!finalOutput.Join && finalOutput.Column.length > 0)) {
                axios.post(process.env.REACT_APP_API_POINT + "DQ-workflow/dq-custom-workflow-submit", { Jsondata: finalOutput }, { headers: { Authorization: 'Bearer ' + sessionStorage.getItem('token') } }).then((data) => {
                    console.log(data)
                })
            } else {
                alert(finalOutput.Join ? "Please Check Secondry Tables and Columns" : "Please Check Columns ")
            }
        }
        else {
            alert("Please Check the Primary Table and Key")
        }
    }


    function setPrimaryTable(e) {
        if (e == 'Select Table') {
            SetKeys([])

            setTable(null)
        } else {
            let col = [...allColumns]
            if (table) {
                table['Columns'].forEach((c) => {

                    col.forEach((d, ind) => {
                        if (d.display == table["Name"] + '.' + c['Column_Name']) {
                            if (d.count > 1) {
                                d.count--
                            } else {
                                col.splice(ind, 1)
                            }
                        }
                    })
                })
            }
            setTable(e ? JSON.parse(e.target.value) : {})
            let value = JSON.parse(e.target.value)
            value['Columns'].forEach((c) => {
                let flag = false
                col.forEach((d) => {
                    if (d.display == value["Name"] + '.' + c['Column_Name']) {
                        flag = true
                        d.count++
                    }
                })
                if (!flag) {
                    c.display = value["Name"] + '.' + c['Column_Name']
                    c.count = 1
                    col.push(c)
                }
            })
            selectColumn(JSON.stringify(col[0]), 0, true)
            setAllColumns(col)
            SetKeys(JSON.parse(e.target.value).Primary_key)
        }
    }
    function deleteTable(index) {
        let temp = [...listItems]
        let col = [...allColumns]
        if (temp[index]["table_selected"]) {
            temp[index]["table_selected"]['Columns'].forEach((c) => {

                col.forEach((d, i) => {
                    if (d.display == temp[index]["table_selected"]["Name"] + '.' + c['Column_Name']) {
                        if (d.count > 1) {
                            d.count--
                        } else {
                            col.splice(i, 1)
                        }
                    }
                })
            })
        }
        temp.splice(index, 1)
        setAllColumns(col)
        setListItems(temp)
    }

    function deleteColumns(i) {
        let temp = [...columnItems]
        temp.splice(i, 1)
        setColumnItems(temp)
    }
    function selectJoinApply() {

        if (joinApp) {

            let col = []
            if (table) {
                table['Columns'].forEach((c) => {


                    c.display = table["Name"] + '.' + c['Column_Name']
                    col.push(c)
                })
                setAllColumns(col)
            } else {
                setAllColumns([])
            }
            setListItems([{ columnList: [{}] }])

        }
        setJoinApp(!joinApp)
    }


    return (<>
        <div className='bg-white topics'>
            <div className="row">
                <div className="col-12 grid-margin stretch-card">
                    <div className="card bg-white border0 text-dark">
                        <div className="card-body py-0 px-0 px-sm-3">
                            <div className="row ">
                                <div className="col-12 col-sm-12 col-xl-12 p-0">
                                    <h2 className="mb-1 mb-sm-0 text-dark">Custom Workflow : Get Started with Workflow templates</h2>
                                    <p className="mb-0 font-weight-normal mx-4 my-2 d-none  d-sm-block">Save Time With Workflow,Quickly Setup Automated Processes using pre-built templates</p>
                                    {/* section start */}
                                    <div className="d-flex justify-content-end align-items-center " ><input type="checkbox" className="" onClick={() => { selectJoinApply() }} checked={joinApp}></input><span className="m-1">Apply Join</span><button className="mr-2 btn   text-dark swapButton" disabled={!joinApp} onClick={() => { addTables() }}><span>Add Table</span></button><button className="btn btn-primary swapButton " onClick={() => { submit() }}> Submit</button></div>

                                    <div className="card   text-dark mt-3" style={{ backgroundColor: activeItem == 0 ? "#f2f7f7" : "white", cursor: "pointer" }} >
                                        <div className="d-flex justify-content-center">
                                            <div className="div ">

                                                <div className="col-md-2 col-lg-2 col-sm-12 py-3 mx-2" >
                                                    <div className="row">
                                                        <div className="col-md-12 col-sm-12 col-lg-12" >
                                                            <select className="form-control " style={{ backgroundColor: "#fb7073", color: "white", width: "15rem", border: "1px solid black" }} onChange={(e) => { setPrimaryTable(e) }} >
                                                                <option disabled={table}>Select Table</option>
                                                                {tables && tables.length > 0 && tables.map((table) => { return <option value={JSON.stringify(table)}>{table['Name']}</option> })}
                                                            </select>
                                                        </div>

                                                    </div>
                                                    {joinApp && <div className="col-md-12 col-sm-12 col-lg-12">
                                                        <select className="form-control  my-2" style={{ width: "12rem", backgroundColor: "#fb7073", color: "white" }} onChange={(e) => { setKey(e.target.value) }}>
                                                            <option>Select Key</option>
                                                            {keys.map((key) => { return <option value={key}>{key}</option> })}
                                                        </select>
                                                    </div>}

                                                    {/* <div className=" p-4 mt-3" style={{ border: "1px solid black", width: "15rem" }}>
                                                        <div className="d-flex justify-content-start"><div><input type="radio" className="mx-1" name="logic" />AND</div><div className="mx-2"> <input className="mx-1" type="radio" name="logic" />OR</div></div>
                                                        <select className="form-control bg-white my-1" >
                                                            <option>Select Column</option>
                                                        </select>
                                                        <div className="d-flex justify-content-center"><select className="form-control bg-white w-50 my-1" >
                                                            <option> Filter</option>
                                                        </select></div>
                                                        <input className="form-control bg-white my-1" type={'text'} placeholder="value"></input>
                                                    </div> */}
                                                    <div className="row" style={{ width: "15rem", margin: "0px", padding: "0px" }}>
                                                        <div className="col-6" style={{ borderRight: "2px solid black", height: "2rem" }}></div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                       {joinApp&&listItems.length>=3 && <div class="d-flex justify-content-between m-2">
                                            <button
                                                style={{ border: "none", backgroundColor: "transparent" }}
                                                onClick={() => {
                                                    handleHorizantalScroll(elementRef.current, 10, 200, -15);
                                                }}
                                                
                                            >
                                                <FaArrowLeft />
                                            </button>
                                            <button style={{ border: "none", backgroundColor: "transparent" }}
                                                onClick={() => {
                                                    handleHorizantalScroll(elementRef.current, 10, 200, 15);
                                                }}
                                            >
                                                <FaArrowRight />
                                            </button>
                                        </div>}
                                        <div className=" card-body  text-black  p-0">
                                            {joinApp && <div className={listItems.length > 4 ? " outer d-flex" : "outer d-flex justify-content-center"} ref={elementRef}>


                                                {listItems.map((item, index) => {
                                                    return (
                                                        <>
                                                            <div className="div " >
                                                                {listItems.length > 1 && <div className="row">
                                                                    <div className="col-6" style={{ borderRight: index == listItems.length - 1 ? "2px solid black" : "none", height: "2rem", borderTop: index == 0 ? "none" : "2px solid black" }}></div>
                                                                    <div className="col-6" style={{ borderRight: index == listItems.length - 1 ? "none" : "none", borderLeft: index == listItems.length - 1 ? "none" : "2px solid black", height: "2rem", borderTop: index == listItems.length - 1 ? "none" : "2px solid black" }}></div>

                                                                </div>}
                                                                <div className="d-flex justify-content-center" >
                                                                    <select className="form-control  m-3" value={item.join ? JSON.stringify(item.join) : 'Join'} style={{ width: "6rem", marginLeft: "50%", backgroundColor: "#1ab981", color: "white" }} onChange={(e) => { selectJoin(index, e.target.value) }}>
                                                                        <option disabled={item.join}>Join</option>
                                                                        {joins && joins.length > 0 && joins.map((join) => { return <option value={JSON.stringify(join)}>{join['Filter Name']}</option> })}
                                                                    </select>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-6" style={{ width: "15rem", height: "2rem", borderRight: "2px solid black" }}></div>
                                                                    {listItems.length > 1 && <div className="col-6" onClick={() => { deleteTable(index) }}><AiFillDelete></AiFillDelete></div>}
                                                                </div>

                                                                <div className="col-md-2 col-lg-2 col-sm-12 py-3 mx-4" >
                                                                    <div className="row">
                                                                        <div className="col-md-12 col-sm-12 col-lg-12">
                                                                            <select className="form-control " value={item.table_selected ? JSON.stringify(item.table_selected) : 'Select Table'} style={{ width: "15rem", border: "1px solid black", backgroundColor: "#2cd5c0", color: "white" }} onChange={(e) => { selectTable(e.target.value, index) }}>
                                                                                <option disabled={item.table_selected}>Select Table</option>
                                                                                {tables && tables.length > 0 && tables.map((table) => { return <option value={JSON.stringify(table)}>{table['Name']}</option> })}
                                                                            </select>
                                                                        </div>

                                                                    </div>
                                                                    <div className="col-md-12 col-sm-12 col-lg-12">
                                                                        <select className="form-control my-2" value={item.selectedKey ? item.selectedKey : 'Select Key'} style={{ width: "12rem", backgroundColor: "#2cd5c0", color: "white", marginLeft: "1rem" }} onChange={(e) => { selectKey(e.target.value, index) }}>
                                                                            <option disabled={item.selectedKey}>Select Key</option>
                                                                            {item.keys && item.keys.map((key) => { return <option value={key}>{key}</option> })}
                                                                        </select>
                                                                    </div>


                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}
                                            </div>}
                                            <div className="d-flex justify-content-center">
                                                <div >
                                                    {columnItems && columnItems.length > 0 && columnItems.map((col, i) => {
                                                        return (<>

                                                            <div className=" p-4 my-3" style={{ border: "1px solid black", width: "15rem", backgroundColor: "#3b82f6", color: "white" }}>
                                                                {columnItems.length > 1 && <div className="d-flex justify-content-end" onClick={() => { deleteColumns(i) }}><AiFillDelete></AiFillDelete></div>}
                                                                <div className="d-flex justify-content-start"><div>
                                                                    <input type="radio" className="mx-1" name={`logic${i}`} checked={col.selected_operator == 'AND'} onClick={() => { selectOperator(i, "AND") }} style={{ border: "10px solid #EF959D" }} />AND</div><div className="mx-2">
                                                                        <input className="mx-1" type="radio" name={`logic${i}`} onClick={() => selectOperator(i, "OR")} checked={col.selected_operator == 'OR'} />OR</div></div>
                                                                <select className="form-control bg-white my-1" value={col.selected_column ? JSON.stringify(col.selected_column) : 'Select Column'} onChange={(e) => { selectColumn(e.target.value, i) }}>
                                                                    <option disabled={col.selected_column} >Select Column</option>
                                                                    {allColumns && allColumns.length > 0 && allColumns.map((col) => { return <option value={JSON.stringify(col)}>{col["display"]}</option> })}
                                                                </select>
                                                                <div className="d-flex justify-content-center"><select value={col.selected_filter ? JSON.stringify(col.selected_filter) : 'Filter'} className="form-control bg-white w-100 my-1" id="filer" onChange={(e) => { selectFilter(e.target.value, i) }}>
                                                                    <option disabled={col.selected_filter}> Filter</option>
                                                                    {col.filters && col.filters.map((fil) => { return <><option value={JSON.stringify(fil)} >{fil['Filter Name']}</option></> })}
                                                                </select></div>

                                                                {(col.selected_filter && (col.selected_filter['Filter Name'] != 'sum' && col.selected_filter['Filter Name'] != 'avg' && col.selected_filter['Filter Name'] != 'max' && col.selected_filter['Filter Name'] != 'min' && col.selected_filter['Filter Name'] != 'count')) && <input className="form-control bg-white my-1" type={col.selected_filter ? col.selected_filter['Filter Type'] : 'text'} value={col.value ? col.value : ''} onInput={(e) => { selectValue(i, e) }} placeholder="value" style={{ color: "black" }}></input>}
                                                            </div> </>)
                                                    })}

                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-center"  >
                                                <span className="p-1 d-flex " style={{ borderRadius: "40px", border: "2px solid #fff", backgroundColor: "#55B7E4" }} onClick={() => { addColumn() }}>
                                                    <AiOutlinePlus style={{ color: "#fff" }}  ></AiOutlinePlus>
                                                </span></div>
                                        </div>

                                    </div>



                                    {/* section ends */}



                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </>)
}
export default Dashboard4;